var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 27.9688C10.9375 32.2812 14.9375 34.4375 20 34.4375C25.0625 34.4375 29.0625 32.2812 32 27.9688C31.9375 26.2188 30.5312 24.75 27.7812 23.5625C25.0312 22.375 22.4375 21.7812 20 21.7812C17.5625 21.7812 14.9688 22.375 12.2188 23.5625C9.46875 24.6875 8.0625 26.1562 8 27.9688ZM24.2188 7.8125C23.0312 6.625 21.625 6.03125 20 6.03125C18.375 6.03125 16.9688 6.625 15.7812 7.8125C14.5938 9 14 10.4062 14 12.0312C14 13.6562 14.5938 15.0625 15.7812 16.25C16.9688 17.4375 18.375 18.0312 20 18.0312C21.625 18.0312 23.0312 17.4375 24.2188 16.25C25.4062 15.0625 26 13.6562 26 12.0312C26 10.4062 25.4062 9 24.2188 7.8125ZM5.84375 5.9375C9.78125 2 14.5 0.03125 20 0.03125C25.5 0.03125 30.1875 2 34.0625 5.9375C38 9.8125 39.9688 14.5 39.9688 20C39.9688 25.5 38 30.2188 34.0625 34.1562C30.1875 38.0312 25.5 39.9688 20 39.9688C14.5 39.9688 9.78125 38.0312 5.84375 34.1562C1.96875 30.2188 0.03125 25.5 0.03125 20C0.03125 14.5 1.96875 9.8125 5.84375 5.9375Z",
    fill: "#1ea149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.bda95547f2e80526c664489a9d0b56fd.svg";
export { ForwardRef as ReactComponent };